import React, { useEffect } from 'react';
import { company_fields } from '../constants/create_company_fields';
import CustomInput from '../../../../components/CustomInput';
import { Button, Typography } from '@mui/material';
import * as MATERIEL_ICONS from '@mui/icons-material/';
import service from '../service';

import { toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import { useBoundStore } from '../../../../stores';

function EditCompanyDrawer() {
  const [companyFormData, setCompanyFormData] = React.useState({
    companyName: '',
    address: '',
    description: '',
  });

  const navigate = useNavigate();
  const { hash } = useLocation();

  const toggleLeftDrawer = useBoundStore((state) => state.toggleLeftDrawer);

  const getCompany = async () => {
    const response = await service.getCompanyById({
      id: hash.split('#')[1]
    });
    const comData = response?.data;
    setCompanyFormData(() => ({
      ...comData,
      productName: comData.productName,
      productType: comData.productType,
      barcodeNumber: comData.barcodeNumber,
      description: comData.description,
      status: comData.status,
    }));
  };

  const handleUpdate = async () => {
    // console.log(formData.companyFormData);
    await service.updateCompany({
      companyId: companyFormData?.id,
      data: companyFormData,
    }).then((response) => {
      if (response?.status === 200 || response?.status === 201) {
        toast.success('Şirket başarıyla güncellendi.');
      } else {
        toast.error('Şirket güncellenirken bir hata oluştu.');
      }
      navigate('/definitions/companies');
      toggleLeftDrawer();
    });
  };

  useEffect(() => {
    getCompany();
  }, [hash]);

  return (
    <div className="mt-5">
      <div className="px-2">
        <Typography variant="h6">Şirket Güncelle</Typography>
      </div>
      <div>
        {/* <EditProgressStepper
          formData={{
            companyFormData,
            matchWith: {
              vehicle: vehicle?.id,
              relationId: currentMatch?.id,
            },
          }}
          steps={['Cihaz Bilgileri'
            // , 'Araçla Eşleştir'
          ]}
        > */}
        <>
          <div>
            <div className="flex flex-row flex-wrap justify-center items-center gap-4 w-full my-5">
              {company_fields().map((field, index) => {
                return (
                  <div className=" flex w-full" key={index}>
                    <CustomInput
                      key={index}
                      type={field.type}
                      inputType={field.inputType}
                      defaultValue={field.defaultValue}
                      items={field.items}
                      label={field.placeHolder}
                      value={
                        companyFormData !== undefined
                          ? companyFormData[field.key]
                          : ''
                      }
                      fullWidth={true}
                      size={'small'}
                      onChange={(key, value) => {
                        setCompanyFormData({
                          ...companyFormData,
                          [field.key]: value,
                        });
                      }}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </>
        {/* <>
            <div className="w-full">
              <div className="flex justify-center items-center">
                Güncel eşleşme: {currentMatch?.vehicle?.id}
              </div>
              <div className="flex flex-row flex-wrap justify-center items-center gap-4 w-full my-5">
                <Autocomplete
                  fullWidth
                  options={vehicles}
                  getOptionLabel={(option) => option?.id}
                  onChange={(e, value) => {
                    setVehicle(value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Araç Seçin"
                      variant="outlined"
                      size="small"
                      onChange={(e) => handleFilterInput(e.target.value)}
                      value={filterData.query}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {isLoading ? (
                              <CircularProgress color="inherit" size={20} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              </div>
            </div>
          </> */}
        {/* </EditProgressStepper> */}
        <div className="flex justify-center items-center my-5">
          <Button
            fullWidth
            disabled={hash === '' || companyFormData === undefined}
            variant="contained"
            color="primary"
            onClick={handleUpdate}
            startIcon={<MATERIEL_ICONS.Save />}
          >
            Kaydet
          </Button>
        </div>
        {hash === '' ? (
          <div className="p-2 m-2  flex justify-center items-center">
            <span className="italic">Lütfen bir şirket seçiniz.</span>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default EditCompanyDrawer;
